import {
    Button,
    Checkbox,
    CircularProgress,
    Tooltip,
    TextField
} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import {
    CheckBox,
    CheckBoxOutlineBlank, KeyboardArrowDown, KeyboardArrowRight
} from "@material-ui/icons";
import DoneAllIcon from '@material-ui/icons/DoneAll';
import Autocomplete from "@material-ui/lab/Autocomplete";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { globalStyles } from "../../assets/globalStyles";
import { onDropDownSelect, selectFilteredMessgroessenOfGroup, selectListLoading } from "./netzwirtschaftSlice";
import { useStyles } from "./netzwirtschaftStyles";
import { TabData } from "./netzwirtschaftTypes";


export interface NetzwirtschaftAutocompleteMessgroeseProps {
    tabData: TabData;
    openGroups: string[];
    selectedGroups: string[];
    setOpenGroups: (newValue: string[]) => void;
    setSelectedGroups: (newValue: string[]) => void;
}
export const NetzwirtschaftAutocompleteMessgroese = ({ tabData, openGroups, setOpenGroups, selectedGroups, setSelectedGroups }: NetzwirtschaftAutocompleteMessgroeseProps): JSX.Element => {
    const dispatch = useAppDispatch();

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };



    const listLoading: boolean = useAppSelector(selectListLoading);


    const [messgroesseSelectInputValue, setMessgroesseSelectInputValue,] = React.useState("");

    return (

        <Grid item xs={11} md={11} >
            <FormControl className={classes.fullWidth}
                disabled={
                    tabData.fields.rekorder.klasse == "" ||
                    (new Date(tabData.fields.ersteDaten).getTime() ==
                        new Date(0).getTime() &&
                        new Date(tabData.fields.letzteDaten).getTime() ==
                        new Date(0).getTime())
                }
            >
                <Autocomplete
                    multiple
                    id="select-messgroesse"
                    noOptionsText={<React.Fragment>
                        {listLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine Messgrößen"}</React.Fragment>}
                    limitTags={6}
                    value={tabData.fields.messgroesse}
                    // getOptionDisabled={(option) =>
                    //   e.fields.messgroesse.length < 6
                    //     ? false
                    //     : !e.fields.messgroesse.find(
                    //         (element) => element === option
                    //       )
                    // }
                    onChange={(_, newValue) => {
                        dispatch(
                            onDropDownSelect({
                                field: "messgroesse",
                                value: newValue !== null ? newValue : []
                            })
                        );
                        setSelectedGroups(newValue.filter(x => {
                            const allMessgroessenForThisKat = tabData.messgroesseOptions.filter(mv => mv.unterkategorie == x.unterkategorie).length;
                            const selectedMessgroessenForThisKat = newValue.filter(mv => mv.unterkategorie == x.unterkategorie).length;
                            return allMessgroessenForThisKat == selectedMessgroessenForThisKat;
                        }).map(x => x.unterkategorie as string));
                    }}
                    inputValue={messgroesseSelectInputValue}
                    onInputChange={(_, newInputValue, reason) => {
                        if (reason == "reset") return;
                        setMessgroesseSelectInputValue(newInputValue);
                    }}
                    onClose={() => setMessgroesseSelectInputValue("")}
                    disableCloseOnSelect
                    groupBy={(option) => option.unterkategorie ? option.unterkategorie : ""}
                    options={tabData.messgroesseOptions}
                    getOptionLabel={(option) => (option ?
                        option.beschreibung + " (" + option.feldname + ")" : "")}
                    renderGroup={(params) => {
                        return tabData.messgroesseOptions.every(x => x.unterkategorie != null) ?
                            <React.Fragment>
                                <Checkbox
                                    icon={
                                        <CheckBoxOutlineBlank fontSize="small" />
                                    }
                                    checkedIcon={<CheckBox fontSize="small" />}
                                    style={{ marginRight: -10 }}
                                    checked={selectedGroups.includes(params.group)}
                                    indeterminate={!selectedGroups.includes(params.group) && tabData.fields.messgroesse.some(m => m.unterkategorie == params.group)}
                                    onChange={() => {
                                        if (selectedGroups.includes(params.group)) {
                                            setSelectedGroups(selectedGroups.filter(x => x != params.group))
                                            dispatch(selectFilteredMessgroessenOfGroup({ groups: selectedGroups.filter(x => x != params.group), filter: messgroesseSelectInputValue }));
                                        } else {
                                            setSelectedGroups(selectedGroups.concat([params.group]))
                                            dispatch(selectFilteredMessgroessenOfGroup({ groups: selectedGroups.concat([params.group]), filter: messgroesseSelectInputValue }));
                                        }
                                    }
                                    }
                                />
                                <Button style={{ fontWeight: "bold", textTransform: "none", fontSize: "medium" }}
                                    onClick={() => openGroups.includes(params.group) ? setOpenGroups(openGroups.filter(x => x != params.group)) : setOpenGroups(openGroups.concat([params.group]))}>
                                    {openGroups.includes(params.group) ? <KeyboardArrowDown style={{ marginRight: 10 }} /> : <KeyboardArrowRight style={{ marginRight: 10 }} />}{params.group}
                                </Button>
                                {openGroups.includes(params.group) ? params.children : ""}
                                <br />
                            </React.Fragment> :
                            params.children
                    }}
                    renderOption={(option, { selected }) => (
                        <React.Fragment>
                            <Checkbox
                                icon={
                                    <CheckBoxOutlineBlank fontSize="small" />
                                }
                                checkedIcon={<CheckBox fontSize="small" />}
                                style={{ marginLeft: 12, marginRight: 12, paddingTop: 1, paddingBottom: 1 }}
                                checked={selected}
                            />
                            {option.beschreibung + " (" + option.feldname + ")"}
                        </React.Fragment>
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Messgrößen"
                            variant="outlined"
                            classes={{
                                root: classes.textFieldRoot, // apply class here
                            }}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <React.Fragment>
                                        <div>
                                            <Tooltip title="Alle Messgrößen selektieren">
                                                <Button
                                                    size="small"
                                                    variant="contained"
                                                    color="secondary"
                                                    disabled={
                                                        tabData.fields.rekorder.klasse == "" ||
                                                        (new Date(tabData.fields.ersteDaten).getTime() ==
                                                            new Date(0).getTime() &&
                                                            new Date(tabData.fields.letzteDaten).getTime() ==
                                                            new Date(0).getTime())
                                                    }
                                                    style={{marginRight: "32px"}}
                                                    onClick={() => {
                                                        setSelectedGroups(tabData.messgroesseOptions.filter(x => x.unterkategorie).map(x => x.unterkategorie as string));
                                                        dispatch(selectFilteredMessgroessenOfGroup({ groups: null, filter: messgroesseSelectInputValue }));
                                                    }}
                                                >
                                                    <DoneAllIcon />
                                                    Alle
                                                </Button>
                                            </Tooltip>
                                            {params.InputProps.endAdornment}
                                        </div>
                                    </React.Fragment>
                                ),
                            }}
                        />
                    )}

                    disabled={
                        tabData.fields.rekorder.klasse == "" ||
                        (new Date(tabData.fields.ersteDaten).getTime() ==
                            new Date(0).getTime() &&
                            new Date(tabData.fields.letzteDaten).getTime() ==
                            new Date(0).getTime())
                    }
                    className={classes.selectEmpty}
                />
            </FormControl>
        </Grid>

    );
}
